import PageShell from '../components/PageShell'
import { PLANS, TRIAL_NOTE, TEAM_SIZE_NOTE, APP_REGISTER_URL } from '../content/site'

export default function PricingPage() {
  return (
    <PageShell
      title="Pricing"
      intro={`${TRIAL_NOTE} Monthly or annual billing — annual plans save 20%.`}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {PLANS.map((plan) => (
          <div
            key={plan.name}
            className="relative bg-[#161b22] border border-white/[0.08] rounded-xl p-8 flex flex-col"
          >
            {plan.badge && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[0.68rem] font-bold px-3 py-1 rounded-full uppercase tracking-[0.06em] bg-[#06b6d4] text-[#0d1117]">
                {plan.badge}
              </span>
            )}
            <div className="text-xs font-bold uppercase tracking-[0.1em] text-[#6b7280] mb-2">
              {plan.name}
            </div>
            <div className="text-4xl font-extrabold text-[#f0f6fc] leading-none">
              ${plan.monthly}
              <span className="text-sm font-normal text-[#6b7280]"> / mo</span>
            </div>
            <div className="text-xs text-[#22c55e] mt-2">
              or ${plan.annualMonthly}/mo — ${plan.annualMonthly * 12} billed annually
            </div>
            <div className="text-sm text-[#9ca3af] mt-3 mb-4">{plan.audience}</div>
            <hr className="border-none border-t border-[#21262d] mb-5" />
            <ul className="space-y-2.5 flex-1 mb-6">
              {plan.features.map((f) => (
                <li key={f} className="flex gap-2 text-sm text-[#e6edf3]">
                  <span className="flex-shrink-0 font-bold text-[#22c55e]">✓</span>
                  {f}
                </li>
              ))}
            </ul>
            <a
              href={APP_REGISTER_URL}
              className="block text-center py-3 rounded-lg text-sm font-semibold bg-[#06b6d4] text-[#0d1117] hover:bg-[#22d3ee] transition-all duration-200"
            >
              Start free trial
            </a>
          </div>
        ))}
      </div>

      <section className="mb-4">
        <h2 className="text-xl font-semibold text-white mb-3">Good to know</h2>
        <ul className="space-y-2 text-[15px] text-[#9ca3af] leading-[1.7] list-disc list-inside marker:text-[#6b7280]">
          <li>{TRIAL_NOTE}</li>
          <li>{TEAM_SIZE_NOTE}</li>
          <li>Annual billing saves 20% compared to monthly billing.</li>
        </ul>
      </section>
    </PageShell>
  )
}
